module.exports = __webpack_public_path__ + "img/header-weddingRingsWhitegold@2x.3f24663.jpg";